import LogoutIcon from '@mui/icons-material/Logout';
import { styled } from '@mui/material';

import { Logger } from '@/utils/logger';
import AuthService from '@montugroup/circuit-shared/services/authentication.service';
import { Box } from '@montugroup/design-system';

const logger = new Logger('sidebar/Logout');

const LogoutMenuItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${theme.spacing(4)} 0 ${theme.spacing(4)} ${theme.spacing(7)}`,
  fontWeight: theme.typography.fontWeightMedium,
  fontFamily: theme.typography.fontFamily,
  gap: theme.spacing(4),
  borderRadius: 0,
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
  cursor: 'pointer',
}));

function Logout({ toggleText = true }: { toggleText?: boolean }) {
  return (
    <LogoutMenuItem
      onClick={() => {
        logger.info('LogoutMenuItem onClick');
        AuthService.logout();
      }}
    >
      <LogoutIcon />
      {toggleText && 'Logout'}
    </LogoutMenuItem>
  );
}

export default Logout;
